<template>
  <div class="input-wrap" :class="{'input-focus' : inputFocus || inputValue.toString().length > 0}">
    <label :for="inpid">{{label}} <span class="require" v-if="valueRequire">*</span></label>
    <i-input v-model="inputValue"
             :class="{'has-icon': hasIcon}"
             :element-id="inpid"
             @on-focus="inpFocus"
             @on-blur="inpBlur"
             :placeholder="inputFocus2 ? ('请输入' + label) : ''"
    >
    </i-input>
    <img class="icon" v-if="hasIcon && inputValid === true" src="/static/images/success.png" alt="">
    <img class="icon" v-if="hasIcon && (valueInvalid || inputValid === false)" src="/static/images/fail.png" alt="">
    <span class="error-msg require" v-if="valueInvalid || inputValid === false">{{label === '手机号' ? (inputValue.length === 0 ? '手机号不能为空' : '请输入正确手机号') : label + '不能为空'}}</span>
  </div>
</template>

<script>
  export default {
    props: [
      'label',
      'inpid',
      'valueRequire',
      'valueInvalid',
      'inpValue',
      'hasIcon',
      'reg',
    ],
    data () {
      return {
        inputFocus: false,
        inputFocus2: false,
        inputValue: '',
        inputValid: null
      };
    },
    watch: {
      inputValue () {
        this.$emit('changeInpValue', this.inputValue);
      },
      inpValue () {
        this.inputValue = this.inpValue;
      },
    },
    methods: {
      inpFocus () {
        this.inputFocus = true;
        setTimeout(() => {
          this.inputFocus2 = this.inputFocus;
        }, 200);
      },
      inpBlur () {
        this.inputFocus = false;
        this.inputFocus2 = this.inputFocus;
        if (this.reg) {
          this.inputValid = this.reg.test(this.inputValue);
        } else if (this.valueRequire) {
          this.inputValid = this.inputValue.length > 0;
        } else {
          this.inputValid = this.inputValue.length > 0 ? true : null;
        }
      }
    },
    mounted () {
    }
  };
</script>

<style lang="scss">
  .input-wrap {
    display: inline-block;
    position: relative;
    border-radius: 6px;
    .ivu-input-wrapper,
    .ivu-input-number,
    .ivu-input-number-input-wrap {
      width: 100%;
      height: 100%;
      background: rgba(250, 251, 254, 1);
      box-shadow: 0px 0px 4px 0px rgba(88, 88, 88, 0.23);
      border-radius: 6px;
      color: #666;
      border: none;
      /*.ivu-input-icon {
        top: 50%;
        margin-top: -16px;
      }*/
      &.has-icon {
        width: calc(100% - 34px);
      }
      .ivu-input-group-append {
        width: 46px;
        height: 46px;
        line-height: 45px;
        color: #fff;
        font-size: 20px;
        background: #3C86FF;
        border: none;
        cursor: pointer;
        padding: 0;
        & > div {
          width: 100%;
          height: 100%;
        }
      }
    }
    .ivu-input-number-handler-wrap {
      display: none;
    }
    input {
      width: 100%;
      height: 46px;
      padding: 10px 0;
      background: rgba(250, 251, 254, 1);
      border-radius: 6px;
      padding-left: 20px;
      font-size: 14px;
      color: #666;
      border: none;
      &:focus {
        box-shadow: none;
      }
    }
    label {
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      font-weight: 600;
      position: absolute;
      left: 20px;
      top: 13px;
      transition: all .3s;
      -webkit-transition: all .3s;
      z-index: 10;
    }
    &.input-focus {
      label {
        top: -10px;
        background-color: #fff;
        font-size: 12px;
      }
    }
    .icon {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-left: 6px;
    }
  }

  span.require {
    vertical-align: middle;
    font-size: 16px;
    color: #f00;
  }

  span.error-msg {
    display: block;
    width: 100%;
    font-weight: 400!important;
    font-size: 12px;
    line-height: 1;
    margin-top: 8px;
    float: left;
    margin-left: 8px;
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// src/components/InputWithLabel.vue